import React, { Suspense } from "react";
import GridFullHeight from "components/GridFullHeight";
import { Route, Switch } from "react-router";
import { reducerType } from "redux/reducers";
import { connect } from "react-redux";
import loading from "asset/img/loading.svg";
import ServiceDetail from "pages/ServiceDetail";
import MyFavorites from "pages/MyFavorites";
import CrisisLines from "pages/CrisisLines";
import Introduce from "pages/Introduce";
import PrivacyPolicy from "pages/PrivacyPolicy";
import TermsOfUse from "pages/TermsOfUse";
import About from "pages/About";
import Feedback from "pages/Feedback";
import Login from "pages/Auth";
import ForgotPassword from "pages/ForgotPassword";
import ResetPassword from "pages/ResetPassword";
import HomePage from "pages/HomePage";
import OnlyPublicRoute from "./OnlyPublic";
import NotFoundPage from "pages/NotFound";
import ChangePassword from "pages/ChangePassword";
import NewService from "pages/NewService";
import ManageServices from "pages/ManageServices";
import EditService from "pages/EditService";
import CrisisLinesNew from "pages/CrisisLines/create";
import CrisisLinesEdit from "pages/CrisisLines/edit";
import Feedbacks from "pages/Feedbacks";
import AvailableBeds from "pages/AvailableBeds";
import CallbackPage from "pages/Callback";
import ManageApprovals from "pages/ManageApprovals";
// import ManageAccess from "pages/ManageAccess";
import ManageUsers from "pages/ManageUsers";
import UpdateProfile from "pages/UpdateProfile";
import ChatBox from "pages/ChatBox";
import UpdateMyProfile from "pages/UpdateMyProfile";
import AccountDeletionPolicy from "pages/AccountDeletionPolicy";
import { UserRole } from "common";
import PrivateRoute from "./PrivateRoute";
import AdminRoute from "./AdminRoute";
// Volunteer routes
import VolunteerRoute from "./VolunteerRoute";
import ManageVolunteerServices from "pages/ManageVolunteerServices";
import ValidateListServices from "pages/ValidateListServices";
import ManageVolunteers from "pages/ManageVolunteers";
import MyWork from "pages/MyWork";
import LeaderBoard from "pages/LeaderBoard";
import ValidateService from "pages/ValidateService";
import ManageVolunteersWork from "pages/ManageVolunteersWork";
import ManageAppUpdate from "pages/ManageAppUpdate";


const mapStateToProps = (state: reducerType) => ({ auth: state.auth });

type RoutesProps = ReturnType<typeof mapStateToProps>;

const Routes = (props: RoutesProps) => {
  const curUser = props.auth.current_user;
  const roles = curUser.roles || [];
  return (
    <Suspense
      fallback={
        <GridFullHeight
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <img width={50} height={50} src={loading} alt="loading" />
        </GridFullHeight>
      }
    >
      <Switch>
        <Route exact path="/" component={HomePage} />
        <Route
          exact
          path="/account-deletion-policy"
          component={AccountDeletionPolicy}
        />
        <Route exact path="/services/:id" component={ServiceDetail} />
        <Route exact path="/my_favorites" component={MyFavorites} />
        <Route exact path="/crisis_lines" component={CrisisLines} />
        <Route exact path="/introduce" component={Introduce} />
        <Route exact path="/privacy_policy" component={PrivacyPolicy} />
        <Route exact path="/terms_of_use" component={TermsOfUse} />
        <Route exact path="/about" component={About} />
        <Route exact path="/feedback" component={Feedback} />
        <Route exact path="/forgot_password" component={ForgotPassword} />
        <Route exact path="/auth/resetPassword" component={ResetPassword} />
        <Route exact path="/auth/twitter/callback" component={CallbackPage} />
        <Route exact path="/chatbot" component={ChatBox} />
        <OnlyPublicRoute
          path={"/login"}
          component={Login}
          isLoggedIn={Boolean(curUser.isLogin)}
        />
        <PrivateRoute
          path={"/add_service"}
          component={NewService}
          isLoggedIn={Boolean(curUser.isLogin)}
        />
        <PrivateRoute
          path={"/manage_services"}
          component={ManageServices}
          isLoggedIn={Boolean(curUser.isLogin)}
        />
        <PrivateRoute
          path={"/services/:id/edit"}
          component={EditService}
          isLoggedIn={Boolean(curUser.isLogin)}
        />
        <PrivateRoute
          path={"/change_password"}
          component={ChangePassword}
          isLoggedIn={Boolean(curUser.isLogin)}
        />
        <AdminRoute
          path={"/crisis_lines/new"}
          component={CrisisLinesNew}
          isAdmin={Boolean(curUser.isAdmin)}
          isLoggedIn={Boolean(curUser.isLogin)}
        />
        <AdminRoute
          path={"/crisis_lines/:id/edit"}
          component={CrisisLinesEdit}
          isAdmin={Boolean(curUser.isAdmin)}
          isLoggedIn={Boolean(curUser.isLogin)}
        />
        <PrivateRoute
          path="/feedbacks"
          component={Feedbacks}
          isLoggedIn={Boolean(curUser.isLogin)}
        />
        <PrivateRoute
          path="/available_beds"
          component={AvailableBeds}
          isLoggedIn={Boolean(curUser.isLogin)}
        />
        <AdminRoute
          path="/manage_approvals"
          isAdmin={Boolean(
            curUser.isAdmin || roles.includes(UserRole.VolunteerLead)
          )}
          component={ManageApprovals}
          isLoggedIn={true}
        />
        <AdminRoute
          path={"/manage_users"}
          component={ManageUsers}
          isAdmin={Boolean(curUser.isAdmin)}
          isLoggedIn={Boolean(curUser.isLogin)}
        />
        <AdminRoute
          path={"/manage_app_update"}
          component={ManageAppUpdate}
          isAdmin={Boolean(curUser.isAdmin)}
          isLoggedIn={Boolean(curUser.isLogin)}
        />
        <AdminRoute
          path={"/manage_volunteers"}
          component={ManageVolunteers}
          isAdmin={Boolean(
            curUser.isAdmin || roles.includes(UserRole.VolunteerLead)
          )}
          isLoggedIn={Boolean(curUser.isLogin)}
        />
        <AdminRoute
          path={"/users/:id"}
          component={UpdateProfile}
          isAdmin={Boolean(
            curUser.isAdmin || roles.includes(UserRole.VolunteerLead)
          )}
          isLoggedIn={Boolean(curUser.isLogin)}
        />
        <PrivateRoute
          path={"/update_profile"}
          component={UpdateMyProfile}
          isLoggedIn={Boolean(curUser.isLogin)}
        />
        <VolunteerRoute
          path={"/validate_list_services"}
          component={ValidateListServices}
          canAccess={
            curUser.isAdmin ||
            roles.includes(UserRole.Volunteer) ||
            roles.includes(UserRole.VolunteerSenior) ||
            roles.includes(UserRole.VolunteerLead)
          }
          isLoggedIn={Boolean(curUser.isLogin)}
        />
        <VolunteerRoute
          path={"/services/:id/validate"}
          component={ValidateService}
          canAccess={
            curUser.isAdmin ||
            roles.includes(UserRole.Volunteer) ||
            roles.includes(UserRole.VolunteerSenior) ||
            roles.includes(UserRole.VolunteerLead)
          }
          isLoggedIn={Boolean(curUser.isLogin)}
        />
        <VolunteerRoute
          path={"/my-work"}
          component={MyWork}
          canAccess={
            roles.includes(UserRole.Volunteer) ||
            roles.includes(UserRole.VolunteerSenior) ||
            roles.includes(UserRole.VolunteerLead) ||
            roles.includes(UserRole.Administrator)
          }
          isLoggedIn={Boolean(curUser.isLogin)}
        />
        <Route path={"/leaderboard"} component={LeaderBoard} />
        <VolunteerRoute
          path={"/manage_volunteer_services"}
          component={ManageVolunteerServices}
          canAccess={
            curUser.isAdmin ||
            roles.includes(UserRole.VolunteerLead)
          }
          isLoggedIn={Boolean(curUser.isLogin)}
        />
        <VolunteerRoute
          path={"/manage_volunteers_work"}
          component={ManageVolunteersWork}
          canAccess={
            curUser.isAdmin ||
            roles.includes(UserRole.VolunteerLead)
          }
          isLoggedIn={Boolean(curUser.isLogin)}
        />
        <Route path="*" exact={true} component={NotFoundPage} />
      </Switch>
    </Suspense>
  );
};

export default connect(mapStateToProps)(Routes);
